import httpClient from '../httpClient'

export async function createConversion(experiment: string) {
  httpClient.post(`/ab_test_conversions`, {
    experiment,
  })
}
